import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-8161">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-8162">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-8163">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-8164">
            <ArrowLeft className="w-4 h-4" data-id="element-8165" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-8166">NOIZA</div>
          <div className="w-20" data-id="element-8167" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-8168">
        <div className="mb-12" data-id="element-8169">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-8170">
            <FileText className="w-6 h-6 text-white/80" data-id="element-8171" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-8172">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-8173">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-8174">
          <section data-id="element-8175">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8176">
              <span className="text-[#006847]" data-id="element-8177">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8178">
              <p data-id="element-8179">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-8180">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8181">
                <li data-id="element-8182">Haber leído íntegramente este documento</li>
                <li data-id="element-8183">Comprender su contenido en su totalidad</li>
                <li data-id="element-8184">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-8185">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-8186">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8187">
              <span className="text-[#006847]" data-id="element-8188">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8189">
              <p data-id="element-8190">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8191">
                <li data-id="element-8192">Software como servicio (SaaS)</li>
                <li data-id="element-8193">Marketplace digital gastronómico</li>
                <li data-id="element-8194">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-8195">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8196">
                <li data-id="element-8197">Mostrar su menú digital</li>
                <li data-id="element-8198">Recibir pedidos de clientes</li>
                <li data-id="element-8199">Gestionar su operación interna</li>
                <li data-id="element-8200">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-8201">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-8202">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8203">
              <span className="text-[#006847]" data-id="element-8204">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8205">
              <p data-id="element-8206">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8207">
                <li data-id="element-8208">No es proveedor de alimentos</li>
                <li data-id="element-8209">No participa en la preparación de productos</li>
                <li data-id="element-8210">No manipula alimentos en ningún momento</li>
                <li data-id="element-8211">No realiza entregas ni logística</li>
                <li data-id="element-8212">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-8213">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-8214">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-8215">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8216">
              <span className="text-[#006847]" data-id="element-8217">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-8218">
              <p data-id="element-8219">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-8220">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8221">
                <li data-id="element-8222">El restaurante es el único responsable de su operación</li>
                <li data-id="element-8223">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-8224">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-8225">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8226">
                <li data-id="element-8227">Precios</li>
                <li data-id="element-8228">Menú</li>
                <li data-id="element-8229">Horarios</li>
                <li data-id="element-8230">Métodos de pago</li>
                <li data-id="element-8231">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8232">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8233">
              <span className="text-[#006847]" data-id="element-8234">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-8235">
              <div data-id="element-8236">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8237">
                  5.1. Alcance general
                </h3>
                <p data-id="element-8238">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-8239">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8240">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-8241">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8242">
                  <li data-id="element-8243">Calidad de los alimentos</li>
                  <li data-id="element-8244">Estado, frescura o preparación</li>
                  <li data-id="element-8245">Ingredientes utilizados</li>
                  <li data-id="element-8246">Contaminación cruzada</li>
                  <li data-id="element-8247">Problemas de higiene o salubridad</li>
                  <li data-id="element-8248">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8249">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-8250">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8251">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8252">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8253">
                  <li data-id="element-8254">Retrasos en la entrega</li>
                  <li data-id="element-8255">Pérdida de pedidos</li>
                  <li data-id="element-8256">Entregas incompletas</li>
                  <li data-id="element-8257">Errores en dirección</li>
                  <li data-id="element-8258">Conducta de repartidores</li>
                  <li data-id="element-8259">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8260">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8261">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8262">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8263">
                  <li data-id="element-8264">Recepción de pagos</li>
                  <li data-id="element-8265">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8266">Manejo de efectivo</li>
                  <li data-id="element-8267">Confirmación de pagos</li>
                  <li data-id="element-8268">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8269">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8270">
                  <li data-id="element-8271">Pagos no recibidos</li>
                  <li data-id="element-8272">Comprobantes falsos</li>
                  <li data-id="element-8273">Errores en montos</li>
                  <li data-id="element-8274">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8275">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8276">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8277">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8278">
                  <li data-id="element-8279">Reclamos de clientes</li>
                  <li data-id="element-8280">Reembolsos</li>
                  <li data-id="element-8281">Cancelaciones</li>
                  <li data-id="element-8282">Disputas</li>
                  <li data-id="element-8283">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8284">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8285">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8286">
              <span className="text-[#006847]" data-id="element-8287">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8288">
              <p data-id="element-8289">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8290">
                <li data-id="element-8291">Responsable</li>
                <li data-id="element-8292">Legal</li>
                <li data-id="element-8293">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8294">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8295">
                <li data-id="element-8296">Publicar información falsa</li>
                <li data-id="element-8297">Manipular precios de forma engañosa</li>
                <li data-id="element-8298">Simular disponibilidad inexistente</li>
                <li data-id="element-8299">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8300">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8301">
              <span className="text-[#006847]" data-id="element-8302">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8303">
              <p data-id="element-8304">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8305">
                <li data-id="element-8306">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8307">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8308">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8309">
                <li data-id="element-8310">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8311">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8312">
                    <li data-id="element-8313">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8314">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8315">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8316">
              <span className="text-[#006847]" data-id="element-8317">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8318">
              <p data-id="element-8319">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8320">
                <li data-id="element-8321">Menú digital</li>
                <li data-id="element-8322">Gestión de pedidos</li>
                <li data-id="element-8323">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8324">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8325">
                  <p className="font-medium text-white mb-2" data-id="element-8326">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8327">
                    <li data-id="element-8328">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8329">
                  <p className="font-medium text-white mb-2" data-id="element-8330">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8331">
                    <li data-id="element-8332">Propiedad del software</li>
                    <li data-id="element-8333">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8334">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8335">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8336">
              <span className="text-[#006847]" data-id="element-8337">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8338">
              <p data-id="element-8339">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8340">
                <li data-id="element-8341">Disponibilidad continua</li>
                <li data-id="element-8342">Funcionamiento sin interrupciones</li>
                <li data-id="element-8343">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8344">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8345">
                <li data-id="element-8346">Fallas técnicas</li>
                <li data-id="element-8347">Actualizaciones</li>
                <li data-id="element-8348">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8349">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8350">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8351">
              <span className="text-[#006847]" data-id="element-8352">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8353">
              <p data-id="element-8354">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8355">
                <li data-id="element-8356">No está garantizada permanentemente</li>
                <li data-id="element-8357">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8358">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8359">
                <li data-id="element-8360">Destacar o no restaurantes</li>
                <li data-id="element-8361">Modificar posiciones</li>
                <li data-id="element-8362">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8363">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8364">
              <span className="text-[#006847]" data-id="element-8365">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8366">
              <p data-id="element-8367">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8368">
                <li data-id="element-8369">Cumplir con los pagos acordados</li>
                <li data-id="element-8370">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8371">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8372">
                <li data-id="element-8373">Suspender el servicio</li>
                <li data-id="element-8374">Limitar funcionalidades</li>
                <li data-id="element-8375">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8376">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8377">
              <span className="text-[#006847]" data-id="element-8378">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8379">
              <p data-id="element-8380">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8381">
                <li data-id="element-8382">Incumplimiento de términos</li>
                <li data-id="element-8383">Uso indebido</li>
                <li data-id="element-8384">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8385">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8386">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8387">
              <span className="text-[#006847]" data-id="element-8388">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8389">
              <p data-id="element-8390">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8391">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8392">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8393">
              <span className="text-[#006847]" data-id="element-8394">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8395">
              <p data-id="element-8396">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8397">
                <li data-id="element-8398">Pérdidas económicas</li>
                <li data-id="element-8399">Daños indirectos</li>
                <li data-id="element-8400">Lucro cesante</li>
                <li data-id="element-8401">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8402">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8403">
              <span className="text-[#006847]" data-id="element-8404">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8405">
              <p data-id="element-8406">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8407">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8408">
              <span className="text-[#006847]" data-id="element-8409">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8410">
              <p className="font-medium" data-id="element-8411">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8412">
                <li data-id="element-8413">Ha leído este documento completo</li>
                <li data-id="element-8414">Comprende su alcance</li>
                <li data-id="element-8415">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}